import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=3ffb50d7&scoped=true&"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb50d7",
  null
  
)

export default component.exports